import { format, isValid, parseISO } from "date-fns";
import { useSession } from "~/contexts/auth-context";
import { isChaptrEmail } from "~/utils/chaptr-user";
import { useSearchParams } from "~/hooks/use-search-params";

const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/** The `?today=` pin changes rendering only; it is not an access boundary. */
export const useSeasonalToday = () => {
  const [searchParams] = useSearchParams();
  const { user } = useSession();
  const today = format(new Date(), "yyyy-MM-dd");
  const override = searchParams.get("today");

  if (override === null || !isChaptrEmail(user.email)) {
    return today;
  }

  return DATE_KEY_PATTERN.test(override) && isValid(parseISO(override))
    ? override
    : today;
};
